import gettext from 'js-utils/gettext';
import {
    joinValidators,
    makeValidator,
} from 'eventbrite_design_system/utils/validation/validation';
import {
    isProvided,
    makeHasMinLength,
    makeHasMaxLength,
    hasContent,
    isAnEmail,
} from 'js-utils/validators';
import { EMAILS_MISMATCHES } from '../constants';

const EMAIL_VALIDATORS = [
    {
        validator: isProvided,
        errorMessage: gettext('Please enter a valid email address'),
    },
    {
        validator: isAnEmail,
        errorMessage: gettext('Please enter a valid email address'),
    },
];

const PASSWORD_LOGIN_VALIDATOR = [
    {
        validator: isProvided,
        errorMessage: gettext('Password is required'),
    },
];

const PASSWORD_SIGNUP_VALIDATOR = [
    ...PASSWORD_LOGIN_VALIDATOR,
    {
        validator: makeHasMinLength(8),
        errorMessage: gettext('Password must be at least 8 characters'),
    },
];

const FIRST_NAME_VALIDATOR = [
    {
        validator: isProvided,
        errorMessage: gettext('First name is required'),
    },
    {
        validator: hasContent,
        errorMessage: gettext('First name cannot be spaces'),
    },
    {
        validator: makeHasMaxLength(50),
        errorMessage: gettext('First name must be less than 50 characters'),
    },
];

const LAST_NAME_VALIDATOR = [
    {
        validator: isProvided,
        errorMessage: gettext('Last name is required'),
    },
    {
        validator: hasContent,
        errorMessage: gettext('Last name cannot be spaces'),
    },
    {
        validator: makeHasMaxLength(50),
        errorMessage: gettext('Last name must be less than 50 characters'),
    },
];

const userInfoValidate = makeValidator({
    firstName: FIRST_NAME_VALIDATOR,
    lastName: LAST_NAME_VALIDATOR,
});

// 'makeValidator' method only supports validations in current input's value. Creating a validation
// this way we can access both values, current email and confirmEmail.
const confirmEmailValidate = function(
    { confirmEmail },
    { email, shouldIncludeEmailConfirmation },
) {
    // We want to show this error starting from the moment the user writes a wrong character
    // but we can't validate if email is complete here (we use async for that)
    if (
        shouldIncludeEmailConfirmation &&
        (!isProvided(confirmEmail) || !email.includes(confirmEmail))
    ) {
        return {
            confirmEmail: EMAILS_MISMATCHES,
        };
    }
    return true;
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// We use async validate to make sure emails matches after leaving the field. This async validate runs onBlur but redux
// expects a promise so we have to emulate a timeout (as like a backend validation request) to make it work
export const asyncValidateConfirmEmail = function(
    { confirmEmail = '' },
    dispatch,
    { email = '', shouldIncludeEmailConfirmation },
) {
    return sleep(10).then(() => {
        if (shouldIncludeEmailConfirmation && confirmEmail !== email) {
            const error = { confirmEmail: EMAILS_MISMATCHES };

            throw error;
        }
    });
};

export const passwordValidate = makeValidator({
    password: PASSWORD_SIGNUP_VALIDATOR,
});

export const lookUpValidate = makeValidator({
    email: EMAIL_VALIDATORS,
});

export const logInValidate = makeValidator({
    password: PASSWORD_LOGIN_VALIDATOR,
});

export const signUpValidate = joinValidators(
    confirmEmailValidate,
    userInfoValidate,
    passwordValidate,
);

export const SocialSignUpValidate = joinValidators(
    lookUpValidate,
    userInfoValidate,
    passwordValidate,
);
